import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Ajax } from 'app/common/ajax';
import { apiUrl } from 'app/common/url-resolver.service';
import {
  BEmailNotificationsTemplate,
  HolidayGDPRTemplateDataType,
} from './email-notifications-template';

@Injectable()
export class EmailNotificationsTemplateService {
  private readonly URL = apiUrl('templates', 'emails');
  private readonly HOLIDAY_TEMPLATES_URL = apiUrl('templates', 'holiday-templates');
  constructor(private http: HttpClient) {}

  getAllTemplates(params?: { teamId: string }): Observable<BEmailNotificationsTemplate[]> {
    return this.http
      .get<BEmailNotificationsTemplate[]>(this.URL, { params })
      .pipe(map((resp) => BEmailNotificationsTemplate.fromRestArray(resp)));
  }

  createTemplate(data: Partial<BEmailNotificationsTemplate>): Observable<void> {
    return this.http.post<void>(this.URL, data);
  }

  editTemplate(data: Partial<BEmailNotificationsTemplate>): Observable<void> {
    return this.http.put<void>(this.URL, data);
  }

  renderPreview(
    name: string,
    subject: string,
    text: string
  ): Observable<{ subject: string; text: string }> {
    return this.http.put<{ subject: string; text: string }>(
      this.URL,
      { dataForPreview: { name, subject, text } },
      Ajax.X_NO_LOADING_OPTIONS
    );
  }

  softDelete(id: string): Observable<void> {
    const data: Partial<BEmailNotificationsTemplate> = {
      id,
      isDeleted: true,
    };
    return this.http.put<void>(this.URL, data);
  }

  /* Holiday GDPR templates */
  getAllHolidayGDPRTemplates(): Observable<BEmailNotificationsTemplate[]> {
    return this.http
      .get<BEmailNotificationsTemplate[]>(this.HOLIDAY_TEMPLATES_URL, Ajax.X_NO_LOADING_OPTIONS)
      .pipe(map((templates) => BEmailNotificationsTemplate.fromRestArray(templates)));
  }

  createHolidayGDPRTemplate(data: HolidayGDPRTemplateDataType): Observable<void> {
    return this.http.post<void>(this.HOLIDAY_TEMPLATES_URL, data);
  }

  editHolidayGDPRTemplate(data: HolidayGDPRTemplateDataType): Observable<void> {
    return this.http.put<void>(this.HOLIDAY_TEMPLATES_URL, data);
  }

  softDeleteHolidayGDPRTemplate(deleteAll: boolean, id?: string): Observable<void> {
    return this.http.put<void>(
      this.HOLIDAY_TEMPLATES_URL,
      deleteAll ? { deleteAll: true } : { id }
    );
  }
}
